import styled from 'styled-components/macro';

export const ScGoogleAuthDivider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 16px 0;

  &::before,
  &::after {
    content: '';
    flex: 1 0 0;
    min-width: 1px;
    height: 2px;
    border-radius: 1px;
    background: ${({ theme }) => theme.grayColor2};
  }

  & .text-divider {
    font-size: 14px;
    line-height: 22px;
    color: ${({ theme }) => theme.grayColor1};
  }
`;

export const ScGoogleAuthButton = styled.div`
  .btn-content {
    gap: 8px;
  }

  .google-icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }
`;
